<template>
  <button
    v-if="condition"
    class="expand-button"
    :class="`${expandable ? 'expand-button--expandable' : ''} 
    ${expanded ? 'expand-button--expanded' : ''}
     expand-button--${variant} ${
      this.circle ? 'border_radius_40' : 'border_radius_10'
    } ${cls}`"
    v-b-tooltip.hover
    :title="tooltip"
    :disabled="disabled"
    @click="click"
  >
    <span class="expand-button__icon">
      <mdicon v-if="loading" name="loading" size="20" class="spinner" />
      <mdicon v-else :name="icon" size="20" />
    </span>
    <span class="d-md-block d-none expand-button__text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "expand-button",
  props: {
    variant: {
      type: String,
      default: "primary",
    },
    expandable: {
      type: Boolean,
      default: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "information",
    },
    text: {
      type: String,
      default: "متن دکمه",
    },
    cls: {
      type: String,
      default: "",
    },
    tooltip: {
      type: String,
      default: "متن راهنما",
    },
    clickedItem: {
      default: null,
    },
    condition: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    click() {
      this.$emit("click", this.clickedItem);
    },
  },
};
</script>
